import React, {useEffect, useState} from "react";
import {getServiceReportFxn} from "../actions";
import {Card, DatePicker, InputBox, Table} from "../../../components/Elements/appUtils";
import moment from "moment";

const {RangePicker} = DatePicker;

const ServicesReport = () => {
    const [reportData, setReportData] = useState([]);
    const [fromDate, setFromDate] = useState(moment().startOf("day"));
    const [toDate, setToDate] = useState(moment().endOf("day"));

    const ranges = {
        Today: [moment().startOf("day"), moment().endOf("day")],
        "Last Week": [
            moment().subtract(1, "week").startOf("week"),
            moment().subtract(1, "week").endOf("week"),
        ],
        "Last 15 Days": [moment().subtract(14, "days"), moment().endOf("day")],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
    };

    const getReportFxn = async (from = fromDate, to = toDate) => {
        const params = {
            fromDate: moment(from),
            toDate: moment(to),
        };

        const {data} = await getServiceReportFxn(params);
        setReportData(data || []);
    };

    // Initial load
    useEffect(() => {
        getReportFxn();
    }, []);

    // Reload on date change
    useEffect(() => {
        if (fromDate && toDate) {
            getReportFxn(fromDate, toDate);
        }
    }, [fromDate, toDate]);

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Name",
            dataIndex: "productName",
            key: "productName",
        },
        {
            title: "Count",
            dataIndex: "count",
            key: "count",
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (item) => {
                return item ? `Rs. ${item}` : null
            }
        },
    ];

    return (
        <Card title="Service Report">
            <div className="row">
                <div className="col-md-6">
                    <InputBox title="Date">
                        <RangePicker
                            value={[fromDate, toDate]}
                            onChange={(val) => {
                                if (!val) return;
                                setFromDate(val[0]);
                                setToDate(val[1]);
                            }}
                            ranges={ranges}
                        />
                    </InputBox>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12" key={reportData.length}>
                    <div className={'scrollable-table'}>
                        <Table
                            dataSource={reportData}
                            columns={columns}
                            rowKey="_id"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ServicesReport;
